import { action } from 'typesafe-actions';
import { IWallet, enums } from '@kattana-io/common';
import {
  IBigTradesWallet,
  IBigVolumeWallet,
  IWatchedWallet,
  WalletWatchlistTab,
  WatchlistWallet,
} from '../reducers/wallet_watchlist';
import { GetWalletFromWatchlistData } from '../selectors/watchlist';
import { UpdateWatchlistItemPayload } from '../reducers/watchlist';

const entity = 'wallet_watchlist';
const ACTIVATE = `${entity}/ACTIVATE`;
const ADD_WALLET = `${entity}/ADD_WALLET`;
const REMOVE_WALLET = `${entity}/REMOVE_WALLET`;
const REMOVE_WALLET_SUCCESS = `${entity}/REMOVE_WALLET_SUCCESS`;
const UPDATE_WALLET = `${entity}/UPDATE_WALLET`;
const UPDATE_WALLET_SUCCESS = `${entity}/UPDATE_WALLET_SUCCESS`;
const SET_TAB = `${entity}/SET_TAB`;
const SET_CHAIN = `${entity}/SET_CHAIN`;
const SET_WATCHED_WALLETS = `${entity}/SET_WATCHED_WALLETS`;
const SET_TOP_WALLETS = `${entity}/SET_TOP_WALLETS`;
const SET_BIG_TRADES_WALLETS = `${entity}/SET_BIG_TRADES_WALLETS`;
const SET_ACTIVE_WALLETS = `${entity}/SET_ACTIVE_WALLETS`;
const SET_WALLETS = `${entity}/SET_WALLETS`;
const SET_LOADING = `${entity}/SET_LOADING`;

const actionActivateWalletWatchlist = () => action(ACTIVATE);
const actionAddWatchlistWallet = (
  data: GetWalletFromWatchlistData,
  tag?: enums.Tag,
  callback?: () => void
) => action(ADD_WALLET, { data, tag, callback });
const actionRemoveWatchlistWallet = (id: number, callback?: () => void) =>
  action(REMOVE_WALLET, { id, callback });
const actionRemoveSuccessWatchlistWallet = (id: number) =>
  action(REMOVE_WALLET_SUCCESS, id);
const actionUpdateWatchlistWallet = (
  id: number,
  payload: UpdateWatchlistItemPayload
) => action(UPDATE_WALLET, { id, payload });
const actionUpdateSuccessWatchlistWallet = (
  id: number,
  payload: UpdateWatchlistItemPayload
) => action(UPDATE_WALLET_SUCCESS, { id, payload });
const actionSetWatchlistWatchedWallets = (items: Array<IWatchedWallet>) =>
  action(SET_WATCHED_WALLETS, items);
const actionSetWalletWatchlistTab = (tab: WalletWatchlistTab) =>
  action(SET_TAB, tab);
const actionSetWalletWatchlistChain = (chain: string | null) =>
  action(SET_CHAIN, chain);
const actionSetWatchlistWallets = (items: Array<WatchlistWallet>) =>
  action(SET_WALLETS, items);
const actionSetWatchlistTopWallets = (items: IWallet[]) =>
  action(SET_TOP_WALLETS, items);
const actionSetWatchlistBigTradesWallets = (items: IBigTradesWallet[]) =>
  action(SET_BIG_TRADES_WALLETS, items);
const actionSetWatchlistActiveWallets = (items: IBigVolumeWallet[]) =>
  action(SET_ACTIVE_WALLETS, items);
const actionSetWalletWatchlistLoading = (loading: boolean) =>
  action(SET_LOADING, loading);

export {
  ACTIVATE,
  ADD_WALLET,
  REMOVE_WALLET,
  REMOVE_WALLET_SUCCESS,
  UPDATE_WALLET,
  UPDATE_WALLET_SUCCESS,
  SET_TAB,
  SET_CHAIN,
  SET_WATCHED_WALLETS,
  SET_TOP_WALLETS,
  SET_BIG_TRADES_WALLETS,
  SET_ACTIVE_WALLETS,
  SET_WALLETS,
  SET_LOADING,
  actionActivateWalletWatchlist,
  actionAddWatchlistWallet,
  actionRemoveWatchlistWallet,
  actionRemoveSuccessWatchlistWallet,
  actionUpdateWatchlistWallet,
  actionUpdateSuccessWatchlistWallet,
  actionSetWalletWatchlistTab,
  actionSetWalletWatchlistChain,
  actionSetWatchlistWatchedWallets,
  actionSetWatchlistWallets,
  actionSetWatchlistTopWallets,
  actionSetWatchlistBigTradesWallets,
  actionSetWatchlistActiveWallets,
  actionSetWalletWatchlistLoading,
};
